import { api } from '../../api';
import FieldRoutePage from '../components/FieldRoutePage';

// My Tagging Route — the tagger's phone-first day view. Layout and the
// outcome flow live in FieldRoutePage (shared with the sign route).
const CONFIG = {
  fetchRoute: params => api.getMyTaggingRoute(params),
  submitOutcome: (id, fd) => api.submitTaggingOutcome(id, fd),
  summaryField: 'tagging_work_summary',
  specialsLabel: 'Special tagging',
};

export default function TaggingRoutePage() {
  return <FieldRoutePage config={CONFIG} />;
}
